import {
  ProfParamsForm,
  ProfParamsForInscriptionOnStrapi
} from '../../types/user/prof.def';

export const formatProfParamsForInscriptionStrapi = (
  profInfo: ProfParamsForm
): ProfParamsForInscriptionOnStrapi => {
  return {
    ...profInfo,
    username: 'username',
    password: 'password',
    origin: 'register'
  };
};
